import { CloseIcon } from '@chakra-ui/icons';
import { Button, Tooltip } from '@chakra-ui/react';

export const userBaseColumns = [
  {
    name: 'Name',
    selector: (row) => row.label,
    sortable: true,
  },
  {
    name: 'Email',
    selector: (row) => row.value,
    sortable: true,
  },
];

export const userClassColumns = [
  {
    name: 'Name',
    selector: (row) => row.name,
    sortable: true,
  },
  {
    name: 'Email',
    selector: (row) => row.email,
    sortable: true,
  },
];

export const userClassRemoveColumn = (handleRemoveUser) => {
  return {
    name: 'Action',
    selector: (row) => row.value,
    sortable: true,
    cell: (row) => (
      <Tooltip label="Remove" fontSize="xs">
        <Button
          colorScheme="gray"
          size="xs"
          onClick={() => handleRemoveUser(true, row.id)}
        >
          <CloseIcon />
        </Button>
      </Tooltip>
    ),
  };
};

export const userRemoveColumn = (handleRemoveUser) => {
  return {
    name: 'Action',
    selector: (row) => row.value,
    sortable: true,
    cell: (row) => (
      <Tooltip label="Remove" fontSize="xs">
        <Button
          colorScheme="gray"
          size="xs"
          onClick={() => handleRemoveUser(row.value)}
        >
          <CloseIcon />
        </Button>
      </Tooltip>
    ),
  };
};
